import React from 'react';
import {Grid, Typography} from '@material-ui/core';
import {useFlowContext} from 'context/onboarding-flow/OnboardingFlow';

export default function Init() {
    const {flow} = useFlowContext();
    return (
        <Grid
            container
            direction='column'
            justifyContent='center'
            style={{flex: '1 1 auto'}}>
            <Grid item>
                <Typography variant='h4' color='textPrimary' align='center'>
                    {'Bienvenido'}
                </Typography>
                <Typography variant='h3' color='primary' align='center'>
                    {'AML - ONBOARDING'}
                </Typography>
                <Typography variant='h4' align='center'>
                    {flow.data.title}
                </Typography>
            </Grid>
        </Grid>
    );
}
